/**
 * Save a blob through an object URL + hidden anchor. Never a bare `<a href>`
 * to the API (the CSV is bearer-protected). Guarded for jsdom (createObjectURL
 * may be absent); tests spy `saveBlob`.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const create = URL.createObjectURL;
  const revoke = URL.revokeObjectURL;
  if (typeof create !== 'function' || typeof revoke !== 'function') return;
  const url = create.call(URL, blob);
  try {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.rel = 'noopener';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    revoke.call(URL, url);
  }
}
